import { render, staticRenderFns } from "./MemberMemberships.vue?vue&type=template&id=0167c880&"
import script from "./MemberMemberships.vue?vue&type=script&lang=js&"
export * from "./MemberMemberships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports